import { render, staticRenderFns } from "./MarketWarn.vue?vue&type=template&id=4cf16e1a&scoped=true&"
import script from "./MarketWarn.vue?vue&type=script&lang=js&"
export * from "./MarketWarn.vue?vue&type=script&lang=js&"
import style0 from "./MarketWarn.vue?vue&type=style&index=0&id=4cf16e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf16e1a",
  null
  
)

export default component.exports